<template>
  <div>
    <v-layout v-if="!hideMain" wrap>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('name') }}</label>
        <input
          v-model.lazy="filter.fullname"
          type="text"
          :placeholder="$t('name')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Channel') }}</label>
        <multiselect
          v-model="filter.app"
          :options="channelOptions"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('gender') }}</label>
        <multiselect
          v-model="filter.gender"
          :options="genderOptions"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Locale') }}</label>
        <multiselect
          v-model="filter.locale"
          :options="localeOptions"
          label="title"
          select-label
          selected-label
          deselect-label
          track-by="value"
          :multiple="true"
          :placeholder="$t('Locale')"
        >
          <template slot="option" slot-scope="props">
            <flag :iso="props.option.icon" />

            {{ props.option.title }}
          </template>
        </multiselect>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('First Conversation at') }}</label>
        </div>
        <v-layout>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.registerDate.start"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onRegisterStartDate"
            ></datepicker>
          </v-flex>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.registerDate.end"
              style
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onRegisterEndDate"
            ></datepicker>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('Last Conversation at') }}</label>
        </div>
        <v-layout>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.activeDate.start"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onActiveStartDate"
            ></datepicker>
          </v-flex>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.activeDate.end"
              style
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onActiveEndDate"
            ></datepicker>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Email') }}</label>
        <input
          v-model.lazy="filter.email"
          type="text"
          :placeholder="$t('Email')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('phone no.') }}</label>
        <input
          v-model.lazy="filter.phoneno"
          type="text"
          placeholder="Phone No"
          class="form-control"
          maxlength="255"
        />
      </v-flex>

      <v-flex v-if="isKmb" xs12 sm12 class="form-control pa-1">
        <div>
          <label for>{{ $t('create_phone_number_at') }}</label>
        </div>
        <v-layout>
          <v-flex class="form-control pa-1" xs12 sm3>
            <datepicker
              v-model="filter.kmb_create_phone_number.start"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onKmbCreatePhoneNumberStartDate"
            ></datepicker>
          </v-flex>
          <v-flex class="form-control pa-1" xs12 sm3>
            <CustomTimepicker
              name="starttime"
              :value="filter.kmb_create_phone_number.start_time"
              overlay
              format="HH:mm"
              :placeholder="$t('start_time')"
              only-time
              class="pr-1 custom-time-picker"
              @onChange="
                (val) => {
                  filter.kmb_create_phone_number.start_time = val
                }
              "
            >
            </CustomTimepicker>
          </v-flex>
          <v-flex class="form-control pa-1" xs12 sm3>
            <datepicker
              v-model="filter.kmb_create_phone_number.end"
              style
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onKmbCreatePhoneNumberEndDate"
            ></datepicker>
          </v-flex>
          <v-flex class="form-control pa-1" xs12 sm3>
            <CustomTimepicker
              name="starttime"
              :value="filter.kmb_create_phone_number.end_time"
              overlay
              format="HH:mm"
              :placeholder="$t('end_time')"
              only-time
              class="pr-1 custom-time-picker"
              @onChange="
                (val) => {
                  filter.kmb_create_phone_number.end_time = val
                }
              "
            >
            </CustomTimepicker>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('LINEID') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('filterLineId') }">
          <input
            v-model.lazy="filter.lineid"
            type="text"
            class="form-control"
            name="filterLineId"
            data-vv-name="filterLineId"
            :data-vv-as="$t('LINEID')"
            :placeholder="$t('LINEID')"
          />

          <p v-if="errors.has('filterLineId')" class="text-error">
            {{ errors.first('filterLineId') }}
          </p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('School') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('School') }">
          <multiselect
            v-model="filter.school"
            :options="allSchools"
            :options-limit="10"
            :loading="isLoading"
            placeholder="Select one"
            label="name"
            track-by="name"
            @search-change="asyncFindSchools"
          ></multiselect>
          <p v-if="errors.has('School')" class="text-error">{{ errors.first('School') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Province') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Province') }">
          <input
            v-model.lazy="filter.province"
            type="text"
            class="form-control"
            name="Province"
            data-vv-name="Province"
            :data-vv-as="$t('Province')"
            :placeholder="$t('Province')"
          />

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Context') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model.lazy="filter.context"
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Context')"
            :placeholder="$t('Context')"
          />

          <p v-if="errors.has('Context')" class="text-error">{{ errors.first('Context') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Customer Types') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.specialcondition"
            :options="specialconditionOptions"
            :searchable="false"
            label="label"
            track-by="value"
            select-label
            selected-label
            deselect-label
            :placeholder="$t('Conversation')"
          ></multiselect>

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isJuzmatchCrm" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('account_types') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.juzmatch_member_role"
            :options="juzmatchAccountOption"
            :searchable="false"
            label="label"
            track-by="value"
            select-label
            selected-label
            deselect-label
            :placeholder="$t('Conversation')"
          ></multiselect>

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="selectedBot.type === 'summithr'" xs12 sm6 md3 class="form-control pa-1">
        <label>สถานะพนักงาน</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('member_status') }">
          <multiselect
            v-model="filter.member_status"
            :options="
              selectedBot.pageid == '105763258933863' || selectedBot.type === 'summithr'
                ? ['active', 'inactive', 'sign out']
                : ['active', 'inactive']
            "
            :searchable="false"
            select-label
            selected-label
            deselect-label
            placeholder="สถานะพนักงาน"
          ></multiselect>

          <p v-if="errors.has('member_status')" class="text-error">
            {{ errors.first('member_status') }}
          </p>
        </div>
      </v-flex>

      <v-flex v-if="selectedBot.type === 'jamsai'" xs12 sm6 md3 class="form-control pa-1">
        <label>Jamsai ID</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model.lazy="filter.jamsai_id"
            type="text"
            class="form-control"
            name="Jamsai ID"
            data-vv-name="Jamsai ID"
            :data-vv-as="$t('Jamsai ID')"
            :placeholder="$t('Jamsai ID')"
          />

          <p v-if="errors.has('Jamsai ID')" class="text-error">{{ errors.first('Jamsai ID') }}</p>
        </div>
      </v-flex>

      <v-flex
        v-if="$store.state.ntnPage.includes(selectedBot.pageid)"
        xs12
        sm6
        md3
        class="form-control pa-1"
      >
        <label for>{{ $t('Recurring Notification Status') }}</label>
        <multiselect
          v-model="opt_in"
          :options="optInOption"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="onSelectOptIn"
        ></multiselect>
      </v-flex>
      <v-flex v-if="selectedBot.theme == 'sahapan'" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Realname') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model="filter.realname"
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Real name')"
            :placeholder="$t('Real name')"
          />

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="selectedBot.theme == 'aira'" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Aira ID') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model="filter.aira_id"
            type="text"
            class="form-control"
            name="aira_id"
            data-vv-name="aira_id"
            :data-vv-as="$t('Aira Id')"
            :placeholder="$t('Aira Id')"
          />

          <p v-if="errors.has('aira_id')" class="text-error">{{ errors.first('aira_id') }}</p>
        </div>
      </v-flex>

      <v-flex xs6 class="form-control pa-1" :class="{ 'has-error': errorFilterTag.length > 0 }">
        <label for>{{ $t('Tag') }}</label>
        <template v-if="showTagType || $store.state.toaNewDealerPage.includes(selectedBot.pageid)">
          <v-radio-group v-model="filter.tagtype" color="primary" row class="text-xs-center">
            <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
            <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
          </v-radio-group>
          <TagProvider v-slot="{ initialized, items, onSearch }" :persistent-items="persistentTags">
            <tags
              v-if="initialized"
              v-model="tag"
              :tags="tags"
              style="margin-bottom: 5px"
              :btn-text="$t('Add tag')"
              :item-option="items"
              :combobox="true"
              @tags-changed="addTags"
              @before-adding-tag="checkTag"
              @onSearch="onSearch"
            ></tags>
          </TagProvider>
        </template>
        <template v-else>
          <TagProvider v-slot="{ initialized, items, onSearch }" :persistent-items="persistentTags">
            <tags
              v-if="initialized"
              v-model="tag"
              :tags="tags"
              style="margin-bottom: 10px"
              :btn-text="$t('Add tag')"
              :item-option="items"
              :combobox="true"
              :edit="false"
              @tags-changed="addTags"
              @before-adding-tag="checkTag"
              @onSearch="onSearch"
            ></tags>
          </TagProvider>
        </template>

        <span v-if="errorFilterTag.length > 0" class="text-error">
          <template v-if="errorFilterTag.includes('overmaxlength')">{{
            $t('Message cannot be longer than 20 alphabets')
          }}</template>
          <template v-else-if="errorFilterTag.includes('duplicate')">{{
            $t('Duplicate Tag')
          }}</template>
        </span>
      </v-flex>
      <v-flex xs12 class="form-control pa-1">
        <label for>{{ $t('Status') }}</label>
        <v-radio-group v-model="filter.statustype" color="primary" row class="text-xs-center">
          <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
          <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
        </v-radio-group>
        <multiselect
          v-model="filter.status"
          :options="userStatus"
          :searchable="true"
          select-label
          selected-label
          deselect-label
          :multiple="true"
          :placeholder="$t('Status')"
          @select="$emit('onChangeStatus')"
          @remove="$emit('onChangeStatus')"
        ></multiselect>
      </v-flex>
      <v-flex v-if="isGpfBuddy" xs12>
        <div class="mt-4">
          <div class="hr"></div>
          <div class="py-4 px-2">
            <v-layout row wrap>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('company') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_company_code"
                      :options="gpfBuddyOption.companies"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="company_code"
                      label="company_name"
                      @input="onChangeGpfBuddyOptions('company')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('work_group') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_group_code"
                      :disabled="
                        filter.gpf_company_code && filter.gpf_company_code.company_code === 'All'
                      "
                      :options="gpfBuddyOption.groups"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="group_code"
                      label="group_name"
                      @input="onChangeGpfBuddyOptions('group')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('department') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_department_code"
                      :disabled="
                        filter.gpf_group_code && filter.gpf_group_code.group_code === 'All'
                      "
                      :options="gpfBuddyOption.departments"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="department_code"
                      label="department_name"
                      @input="onChangeGpfBuddyOptions('department')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('position') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_position_code"
                      :disabled="
                        filter.gpf_department_code &&
                        filter.gpf_department_code.department_code === 'All'
                      "
                      :options="gpfBuddyOption.positions"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="position_code"
                      label="position_name"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
      <v-flex v-if="['toacrm'].includes(selectedBot.theme)" xs12 class="form-control pa-1">
        <label for>{{ $t('Tier') }}</label>
        <multiselect
          v-model="filter.toa_member_tier"
          :options="toaTierOptions"
          :searchable="false"
          select-label
          selected-label
          deselect-label
          :multiple="false"
          :allow-empty="true"
          placeholder="Tier"
          style="max-width: 300px"
        ></multiselect>
      </v-flex>
      <v-flex v-if="isLamy" xs12>
        <div class="py-4 px-2">
          <LamyFilterProduct v-if="isLamy" v-model="value" />
        </div>
      </v-flex>
      <v-flex xs12 class="form-control pa-1">
        <label for>{{ $t('step_message.title') }}</label>
        <multi-select-custom
          v-model="filter.include_page_audience_ids"
          :options="audienceItems"
          label="name"
          track-by="id"
          :placeholder="$t('step_message.select_audience')"
          :multiple="true"
          :clear-on-select="false"
          :close-on-select="false"
          @scroll:end="onScrollEnd"
        >
        </multi-select-custom>
      </v-flex>
      <template v-if="isFacebookConversionConnected">
        <!-- Event Purchase Payment -->
        <v-flex xs12 class="pa-1 mt-1">
          <span>{{ $t('total_purchase_amount') }}</span>
        </v-flex>
        <v-flex xs4 class="form-control pa-1 mt-1">
          <label for>{{ $t('minimum_payment_amount') }}</label>
          <input
            v-model.lazy="filter.filter_event_data_value.min"
            type="text"
            class="form-control"
            data-vv-name="minimum_payment_amount"
            :data-vv-as="$t('minimum_payment_amount')"
            :placeholder="$t('minimum_payment_amount')"
            @input="$emit('update:event', true)"
          />
        </v-flex>
        <v-flex xs4 class="form-control pa-1 mt-1">
          <label for>{{ $t('maximum_payment_amount') }}</label>
          <input
            v-model.lazy="filter.filter_event_data_value.max"
            type="text"
            class="form-control"
            data-vv-name="maximum_payment_amount"
            :data-vv-as="$t('maximum_payment_amount')"
            :placeholder="$t('maximum_payment_amount')"
            @input="$emit('update:event', true)"
          />
        </v-flex>
        <!-- <v-flex xs4 /> -->
        <v-flex xs4 class="pa-1 mt-1">
          <label for>{{ $t('payment_currency') }}</label>
          <div class="d-flex">
            <div style="flex: 1 1 0">
              <v-autocomplete
                v-model.lazy="filter.filter_event_data_value.currency"
                v-validate="{
                  required:
                    Boolean(filter.filter_event_data_value.min) ||
                    Boolean(filter.filter_event_data_value.max)
                }"
                :items="$store.state.currencies"
                name="payment_currency"
                data-vv-name="payment_currency"
                :data-vv-as="$t('payment_currency')"
                :placeholder="$t('payment_currency')"
                hide-details
                outline
                single-line
                @input="$emit('update:event', true)"
              />
              <span v-if="errors.has('payment_currency')" class="red--text">
                {{ errors.first('payment_currency') }}
              </span>
            </div>
            <v-btn
              class="mt-2"
              small
              icon
              style="max-width: 20px"
              @click="
                () => {
                  filter.filter_event_data_value.currency = ''
                  $emit('update:event', true)
                }
              "
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <!-- Event Purchase Quantity -->
        <v-flex xs12 class="pa-1 mt-1">
          <span>{{ $t('order_quantity') }}</span>
        </v-flex>
        <v-flex xs4 class="form-control pa-1 mt-1">
          <label for>{{ $t('minimum_quantity') }}</label>
          <input
            v-model.lazy="filter.filter_event_data_quantity.min"
            type="text"
            class="form-control"
            data-vv-name="minimum_quantity"
            :data-vv-as="$t('minimum_quantity')"
            :placeholder="$t('minimum_quantity')"
            @input="$emit('update:event', true)"
          />
        </v-flex>
        <v-flex xs4 class="form-control pa-1 mt-1">
          <label for>{{ $t('maximum_quantity') }}</label>
          <input
            v-model.lazy="filter.filter_event_data_quantity.max"
            type="text"
            class="form-control"
            data-vv-name="maximum_quantity"
            :data-vv-as="$t('maximum_quantity')"
            :placeholder="$t('maximum_quantity')"
            @input="$emit('update:event', true)"
          />
        </v-flex>
        <v-flex xs4 />
        <!-- Event Purchase Date -->
        <v-flex xs12 class="pa-1 mt-1">
          <span>{{ $t('latest_purchase_date') }}</span>
        </v-flex>
        <v-flex xs4 class="form-control pa-1 mt-1">
          <label for>{{ $t('start_date') }}</label>
          <div style="display: flex">
            <date-picker
              v-model="filter.filter_event_data_time.start_at"
              full-width
              hide-append
              @input="$emit('update:event', true)"
            >
              <template #default="{ computedDate }">
                <input
                  v-model.lazy="computedDate"
                  style="flex: 1 1 0"
                  type="text"
                  class="form-control"
                  data-vv-name="start_date"
                  :data-vv-as="$t('start_date')"
                  :placeholder="$t('start_date')"
                  readonly
                />
              </template>
            </date-picker>
            <v-btn
              small
              icon
              style="max-width: 20px"
              @click="
                () => {
                  filter.filter_event_data_time.start_at = ''
                  $emit('update:event', true)
                }
              "
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-flex>

        <v-flex xs4 class="form-control pa-1 mt-1">
          <label for>{{ $t('end_date') }}</label>
          <div style="display: flex">
            <date-picker
              v-model="filter.filter_event_data_time.end_at"
              full-width
              hide-append
              @input="$emit('update:event', true)"
            >
              <template #default="{ computedDate }">
                <input
                  v-model.lazy="computedDate"
                  type="text"
                  class="form-control"
                  data-vv-name="end_date"
                  :data-vv-as="$t('end_date')"
                  :placeholder="$t('end_date')"
                  readonly
                />
              </template>
            </date-picker>
            <v-btn
              small
              icon
              style="max-width: 20px"
              @click="
                () => {
                  filter.filter_event_data_time.end_at = ''
                  $emit('update:event', true)
                }
              "
            >
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </template>
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import DatePicker from './DatePicker'
import Tags from '@/components/elements/Tags'
import { PAGE } from '@/constants/page.js'
import LamyFilterProduct from '@/components/view/template/lamy/BroadcastFilterProduct.vue'
import LivechatSocialChannel from '@/components/view/livechat/LivechatSocialChannelMixin'
import MultiSelectCustom from './MultiSelectCustom.vue'
import audienceApi from '@/api/audience'
import TagProvider from '@/components/providers/TagProvider'
import { defaultCompleteTag, defaultMoreTag } from '@/utils/tags'
import CustomTimepicker from '@/components/elements/CustomTimepicker2.vue'
import { MEMBER_TYPE_OPTIONS } from '@/constants/juzmatch'

export default {
  components: {
    Multiselect,
    datepicker,
    DatePicker,
    Tags,
    LamyFilterProduct,
    MultiSelectCustom,
    TagProvider,
    CustomTimepicker
  },
  mixins: [LivechatSocialChannel],
  props: {
    value: {
      type: Object,
      default: undefined
    },
    hideMain: {
      type: Boolean,
      default: false
    },
    showTagType: {
      type: Boolean,
      default: false
    },
    isBroadcast: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      payStatus: null,
      opt_in: null,
      allSchools: [],
      isLoading: false,
      filter: this.value,
      channelOptions: [],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      specialconditionOptions: [
        {
          label: this.$t('Active Users'),
          value: 'activeusers'
        },
        {
          label: this.$t('Potential Users'),
          value: 'potentialusers'
        },
        {
          label: this.$t('Purchased Users'),
          value: 'perchasedusers'
        },
        {
          label: this.$t('Loyal Customer'),
          value: 'perchasedusers_royalty'
        },
        {
          label: this.$t('New Customer'),
          value: 'perchasedusers_newcomer'
        }
      ],
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      intents: [],
      errorFilterTag: [],
      tag: '',
      sendNotiMember: false,
      daySendNoti: '',
      tagOptions: [],
      payOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Paid'),
          value: 'S'
        },
        {
          label: this.$t('Pending'),
          value: 'P'
        }
      ],
      optInOption: [
        {
          label: this.$t('get_message'),
          value: 'daily'
        },
        {
          label: this.$t('get_message_expired'),
          value: 'daily_exp'
        }
      ],
      gpfBuddyOption: {
        positions: [],
        companies: [],
        departments: [],
        groups: []
      },
      juzmatchAccountOption: MEMBER_TYPE_OPTIONS.map((item) => ({
        label: this.$t(`juzmatch_member_type.${item.text}`),
        value: item.value
      })),
      toaTierOptions: ['New Member', 'Regular Member', 'Loyalty Member', 'Inactive Member'],
      channelOptionsLine: [
        {
          label: this.$t('Friends'),
          value: 'line'
        },
        {
          label: this.$t('Group'),
          value: 'line-group'
        }
      ],
      // Step message
      audienceIds: [],
      audienceItems: [],
      audienceConfig: {
        page: 1,
        total: 0,
        offset: 0,
        limit: 20,
        isLoading: false
      },
      persistentTags: [defaultCompleteTag, defaultMoreTag]
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
      isFacebookConversionConnected: 'isFacebookConversionConnected'
    }),
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData
    },
    isLamy() {
      return [...this.$store.state.lamyPage].includes(this.selectedBot.pageid)
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    isKmb() {
      return [...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            result = tags.map(function (tag) {
              return { text: tag }
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }
        vm.filter.tags = result.join(',')
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.filter = newVal
    }
  },
  mounted: function () {
    this.getUserTagList()
    if (this.selectedBot) {
      let customOptions = []
      if (['gpf', 'trueid'].includes(this.selectedBot.type)) {
        customOptions.push({
          label: 'Web Chat',
          value: 'webchat'
        })
      }
      if (['gpf'].includes(this.selectedBot.type)) {
        customOptions.push({
          label: 'App Chat',
          value: 'app'
        })
      }
      this.channelOptions = [
        {
          label: this.$t('All'),
          fullValue: 'all',
          value: 'all'
        },
        ...this.socialChannelOptions.map((social) => {
          return {
            value: social.fullValueForUse,
            label: this.$t(social.text)
          }
        }),
        ...customOptions
      ]

      if (this.isGpfBuddy) {
        this.handleInitialGpfBuddy()
      }

      this.getAudience()
    }
  },
  methods: {
    onSelectOptIn(param) {
      this.filter.opt_in = param.value
    },
    onSelectPayStatus(param) {
      this.filter.payStatus = param.value
    },
    async FindSchools(data) {
      let vm = this
      if (!vm.allSchools.length && !vm.isLoading) {
        vm.isLoading = true
        api.getschoollist(data, function (error, response) {
          if (error) {
            console.error(error)
          } else {
            vm.allSchools = response.data
            vm.isLoading = false
          }
        })
      }
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
      this.$emit('onUpdate')
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
      this.$emit('onUpdate')
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
      this.$emit('onUpdate')
    },
    onKmbCreatePhoneNumberStartDate: function (value) {
      if (moment(this.filter.kmb_create_phone_number.end).isBefore(value)) {
        this.filter.kmb_create_phone_number.end = value
      }
      this.filter.kmb_create_phone_number.start = value
      this.$emit('onUpdate')
    },
    onKmbCreatePhoneNumberEndDate: function (value) {
      if (moment(value).isBefore(this.filter.kmb_create_phone_number.start)) {
        this.filter.kmb_create_phone_number.start = value
      }
      this.filter.kmb_create_phone_number.end = value
      this.$emit('onUpdate')
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        this.tagOptions = [
          ...this.persistentTags,
          ...response.result.map((item) => {
            return item.name
          })
        ]
      }
    },
    handleInitialGpfBuddy() {
      const vm = this
      const gpfBuddyMasterData = vm.gpfBuddyMasterData

      let tempCompanyOptions = []
      tempCompanyOptions.push({ company_code: 'All', company_name: 'All', groups: [] })
      tempCompanyOptions.push(...gpfBuddyMasterData)
      vm.gpfBuddyOption.companies = tempCompanyOptions

      let tempGroupOptions = []
      tempGroupOptions.push({ group_code: 'All', group_name: 'All', departments: [] })
      vm.gpfBuddyOption.groups = tempGroupOptions

      let tempDepartmentOptions = []
      tempDepartmentOptions.push({ department_code: 'All', department_name: 'All', positions: [] })
      vm.gpfBuddyOption.departments = tempDepartmentOptions

      let tempPositionOptions = []
      tempPositionOptions.push({ position_code: 'All', position_name: 'All' })
      vm.gpfBuddyOption.positions = tempPositionOptions

      let selectedCompany = null
      if (vm.filter.gpf_company_code && vm.filter.gpf_company_code.company_code !== 'All') {
        selectedCompany = gpfBuddyMasterData.find((el) => {
          return el.company_code === vm.filter.gpf_company_code
        })
        vm.$set(vm.filter, 'gpf_company_code', selectedCompany)
      } else {
        vm.$set(vm.filter, 'gpf_company_code', {
          company_code: 'All',
          company_name: 'All',
          groups: []
        })
      }

      let selectedGroup = null
      if (
        selectedCompany &&
        vm.filter.gpf_group_code &&
        vm.filter.gpf_group_code.group_code !== 'All'
      ) {
        selectedGroup = selectedCompany.groups.find((el) => {
          return el.group_code === vm.filter.gpf_group_code
        })

        vm.$set(vm.filter, 'gpf_group_code', selectedGroup)
      } else {
        vm.$set(vm.filter, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'All',
          departments: []
        })
      }

      let selectedDepartment = null
      if (
        selectedGroup &&
        vm.filter.gpf_department_code &&
        vm.filter.gpf_department_code.department_code !== 'All'
      ) {
        selectedDepartment = selectedGroup.departments.find(
          (el) => el.department_code == vm.filter.gpf_department_code
        )
        vm.$set(vm.filter, 'gpf_department_code', selectedDepartment)
      } else {
        vm.$set(vm.filter, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
      }

      if (vm.filter.gpf_position_code && vm.filter.gpf_position_code.position_code !== 'All') {
        let selectedPosition = selectedDepartment.positions.find(
          (el) => el.position_code == vm.filter.gpf_position_code
        )
        vm.$set(vm.filter, 'gpf_position_code', selectedPosition)
      } else {
        vm.$set(vm.filter, 'gpf_position_code', { position_code: 'All', position_name: 'All' })
      }
    },
    handleSetGpfBuddyOptions() {
      const vm = this
      const selectedCompany = vm.filter.gpf_company_code
      const selectedGroup = vm.filter.gpf_group_code
      const selectedDepartment = vm.filter.gpf_department_code

      if (selectedCompany && selectedCompany.company_code !== 'All') {
        let tempGroupOptions = []
        tempGroupOptions.push({ group_code: 'All', group_name: 'All', departments: [] })
        tempGroupOptions.push(...selectedCompany.groups)
        vm.gpfBuddyOption.groups = tempGroupOptions
      }

      if (selectedGroup && selectedGroup.group_code !== 'All') {
        let tempDepartmentOptions = []
        tempDepartmentOptions.push({
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        tempDepartmentOptions.push(...selectedGroup.departments)
        vm.gpfBuddyOption.departments = tempDepartmentOptions
      }

      if (selectedDepartment && selectedDepartment.department_code !== 'All') {
        let tempPositionOptions = []
        tempPositionOptions.push({ position_code: 'All', position_name: 'All' })
        tempPositionOptions.push(...selectedDepartment.positions)
        vm.gpfBuddyOption.positions = tempPositionOptions
      }
    },
    onChangeGpfBuddyOptions(type) {
      const vm = this
      if (type === 'company') {
        vm.$set(vm.filter, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'All',
          departments: []
        })
        vm.$set(vm.filter, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        vm.$set(vm.filter, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      } else if (type === 'group') {
        vm.$set(vm.filter, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        vm.$set(vm.filter, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      } else if (type === 'department') {
        vm.$set(vm.filter, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      }

      vm.handleSetGpfBuddyOptions()
    },
    onScrollEnd(reached) {
      if (
        reached &&
        !this.audienceConfig.isLoading &&
        this.audienceConfig.total > this.audienceConfig.offset
      ) {
        this.audienceConfig.offset += this.audienceConfig.limit
        this.getAudience()
      }
    },
    async getAudience() {
      if (this.audienceConfig.isLoading) return
      this.audienceConfig.isLoading = true
      try {
        const response = await audienceApi.getAudiences({
          page_id: this.selectedBot.pageid,
          limit: this.audienceConfig.limit,
          offset: (this.audienceConfig.page - 1) * this.audienceConfig.limit,
          is_allowed_broadcast: this.isBroadCast
        })
        if (response.status === 200) {
          const items = response.data.audience || []
          const mapItems = items.map((item) => ({ name: item.name, id: item.id }))
          this.audienceItems = [
            ...new Set([...this.audienceItems, ...mapItems].map(JSON.stringify))
          ].map(JSON.parse)

          this.audienceConfig.total = Number(response.data.total_all_audience || 0)
          this.audienceConfig.isLoading = false
        }
      } catch (error) {
        console.log({ error })
        this.audienceConfig.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterCustomer.vue